import { sendNotification } from "@/business/notifications/application/sendNotification";

export function notificationsUse() {

  async function createNotificationOperation(
    title: string,
    body: string
  ) {
    await sendNotification.execute(
      title,
      body
    );
  }

  return {
    createNotificationOperation,
  };
}
